import {useQueryClient} from '@tanstack/react-query';
import React, {useEffect} from 'react';
import {Outlet, useLocation} from 'react-router-dom';

import {removeAuthTokens} from 'infra/http/utils';
import {clearLocalStorageFeatureFlags} from 'infra/http/utils/clear-local-storage-feature-flags';
import {logEvent} from 'main/analytics/analytics';
import {LogEventEnum} from 'main/analytics/logEventEnum';
import {MaintenancePage} from 'presentation/components';
import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {clearCongenereEligibilityStorage} from 'infra/http/utils/clear-congenere-eligibility-storage';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';

export const RouterListener = () => {
	const queryClient = useQueryClient();
	const resetFacialBiometrics = useFacialBiometricsStore(state => state.resetFacialBiometrics);

	const {isEnabled: inMaintenance} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_UNDER_MAINTENANCE,
	);

	useEffect(() => {
		if (inMaintenance) {
			clearLocalStorageFeatureFlags();
			clearCongenereEligibilityStorage();
			resetFacialBiometrics();
			queryClient.clear();
			removeAuthTokens();
		}
	}, [inMaintenance]);

	const {beneficiary} = useAccountDataStore(store => store.accountData);
	const location = useLocation();

	useEffect(() => {
		logEvent({
			eventName: beneficiary
				? LogEventEnum.ROUTE_VISITED_LOGGED
				: LogEventEnum.ROUTE_VISITED_LOGGED_OUT,
			routeName: location.pathname,
			...(beneficiary && {
				beneficiary: {
					nuCpfC: beneficiary?.nuCpfC,
					nmUsuarioC: beneficiary?.nmUsuarioC,
					tipoUsuarioC: beneficiary?.tipoUsuarioC,
					dtAdesaoC: beneficiary?.dtAdesaoC,
					dtCarenciaC: beneficiary?.dtCarenciaC,
					dtCarenciaOdontoC: beneficiary?.dtCarenciaOdontoC,
					nuContratoC: beneficiary?.nuContratoC,
					nuRegistroPlano: beneficiary?.nuRegistroPlano,
					tipoPlanoC: beneficiary?.tipoPlanoC,
					tipoContratacao: beneficiary?.tipoContratacao,
					nmSocialUsuarioC: beneficiary?.nmSocialUsuarioC,
				},
			}),
		});
	}, [location]);

	if (inMaintenance) {
		return <MaintenancePage />;
	}

	return <Outlet />;
};
